import { render, staticRenderFns } from "./InitialContactCard.vue?vue&type=template&id=504c9fa8"
import script from "./InitialContactCard.vue?vue&type=script&lang=js"
export * from "./InitialContactCard.vue?vue&type=script&lang=js"
import style0 from "./InitialContactCard.vue?vue&type=style&index=0&id=504c9fa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports